<hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content *hlmDialogPortal class="max-h-[90vh] max-w-3xl overflow-y-auto">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Vorschau mit Beispieldaten (DEMO1234)</h3>
      <p hlmDialogDescription>
        So druckt der Server den Gutschein mit dem aktuellen Layout. Diese Ansicht ist verbindlich;
        der Editor ist eine Annäherung.
        @if (productDesign()) {
          Die Vorschau zeigt dein erstes Produkt, solange keines angelegt ist ein Beispielprodukt.
        }
      </p>
    </div>

    <div class="bg-muted flex min-h-[320px] items-center justify-center rounded border p-2">
      @if (loading()) {
        <div class="flex items-center gap-2 text-sm">
          <hlm-spinner />
          Vorschau wird erstellt…
        </div>
      } @else if (error(); as message) {
        <div class="space-y-2 text-center text-sm">
          <p class="text-destructive">{{ message }}</p>
          <button hlmBtn variant="outline" size="sm" type="button" (click)="retry.emit()">
            Erneut versuchen
          </button>
        </div>
      } @else if (imageUrl(); as url) {
        <img
          [src]="url"
          alt="Vorschau des Gutscheins"
          class="max-h-[65vh] w-auto max-w-full shadow" />
      }
    </div>

    <div hlmDialogFooter>
      <button hlmBtn variant="outline" type="button" (click)="close.emit()">Schließen</button>
      <button
        hlmBtn
        type="button"
        [disabled]="downloading() || loading()"
        (click)="download.emit()">
        @if (downloading()) {
          <hlm-spinner />
        } @else {
          <ng-icon name="lucideDownload" />
        }
        PDF herunterladen
      </button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
